import type { FetchService } from '../services/fetch.service.js';

export function audioUtil() {
  return {
    retrieveAudioUrl,
  };
}

async function retrieveAudioUrl(params: {
  fetchService: FetchService;
  podcastEpisodeId: string;
  idToken: string | Promise<string | undefined> | undefined;
}) {
  const { fetchService, idToken, podcastEpisodeId } = params;

  let streamUrl = `${fetchService.getBaseUrl()}/podcast/stream?itemId=${podcastEpisodeId}&token=${await idToken}`;

  const response = await fetchService.get<Response>('/podcast/stream', {
    returnRawResponse: true,
    queryParams: { itemId: podcastEpisodeId },
  });

  if (response.headers.get('content-type')?.includes('application/json')) {
    // Audio is not hosted and streamed by our platform
    streamUrl = (JSON.parse(await response.text()) as { url: string }).url;
  }

  return streamUrl;
}
